import { render, staticRenderFns } from "./LeadsChartsPage.vue?vue&type=template&id=16645bf2&scoped=true&"
import script from "./LeadsChartsPage.vue?vue&type=script&lang=js&"
export * from "./LeadsChartsPage.vue?vue&type=script&lang=js&"
import style0 from "./LeadsChartsPage.vue?vue&type=style&index=0&id=16645bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16645bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16645bf2')) {
      api.createRecord('16645bf2', component.options)
    } else {
      api.reload('16645bf2', component.options)
    }
    module.hot.accept("./LeadsChartsPage.vue?vue&type=template&id=16645bf2&scoped=true&", function () {
      api.rerender('16645bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LeadsChartsPage.vue"
export default component.exports